import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/styles.css'
import './assets/css/colors.css'
import axios from "axios";
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import $ from 'jquery';
import i18n from './i18n'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faLocationDot, faCrosshairs, faMap } from '@fortawesome/free-solid-svg-icons';

library.add(faLocationDot, faCrosshairs, faMap);
window.$ = $;
axios.defaults.baseURL = "https://dash.greenpages-sy.com/api";
// axios.defaults.baseURL = "https://dash.greenpages.z-demos.com/api";
// // axios.defaults.baseURL = "http://127.0.0.1:8000/api";
// axios.defaults.withCredentials = true;

createApp(App).use(router).use(i18n).use(Toast).component('font-awesome-icon', FontAwesomeIcon).mount('#app');